import React from "react";
import AuthMenu from "../../../common/AuthMenu/AuthMenu";
import styles from "./AuthBase.module.css";

export default function AuthBase() {
  return (
    <main id="main" className={styles.wrap}>
      <div className="container py-4 py-lg-5">
        <div className="row g-4 align-items-center">
          {/* LEFT: product context (visible on lg+) */}
          <div className="col-12 col-lg-6 d-none d-lg-block">
            <section>
              <span className={`badge rounded-pill bg-warning-subtle text-warning-emphasis ${styles.badge}`}>
                Public Beta
              </span>
              <h1 className={styles.heroTitle}>Sign in to Pocket&nbsp;Penny</h1>
              <p className={styles.heroLead}>
                Track where money goes. Search fast, clean up transactions quickly, and keep your data private.
              </p>
              <ul className={`list-unstyled ${styles.checklist}`}>
                <li><span className={styles.tick} aria-hidden="true">✔</span> Fast global search (<kbd>/</kbd>)</li>
                <li><span className={styles.tick} aria-hidden="true">✔</span> First-class transfers & inline edits</li>
                <li><span className={styles.tick} aria-hidden="true">✔</span> Local indexing for snappy tables</li>
              </ul>
            </section>
          </div>

          {/* RIGHT: auth card */}
          <div className="col-12 col-lg-6">
            <section className={`card shadow-sm ${styles.card}`}>
              <div className="card-body p-4 p-lg-5">
                <header className="mb-3">
                  <h2 className={styles.cardTitle}>Welcome back</h2>
                  <p className={styles.cardSubtitle}>Pocket Penny is invite-only during private beta.</p>
                </header>

                {/* Invite-first, then sign-in options */}
                <AuthMenu variant="card" />

                <footer className="mt-4 text-center">
                  <small className="text-muted">
                    Need an invite? Contact your sponsor or {""}
                    <a href="mailto:support@pocketpenny.app">support@pocketpenny.app</a>.
                  </small>
                </footer>
              </div>
            </section>
          </div>
        </div>
      </div>
    </main>
  );
}
